export const contactsData = {
    email: 'kondo0113akechi@gmail.com',
    phone: '+1 408 427 3138',
    address: 'Kyoto City, 35 Sennyuji Yamanouchicho',
}